import { Box, styled } from "@mui/material";
import { Button, Typography } from "@pmag/ui-components";
import { ImageStatic } from "@src/components/imageStatic/ImageStatic";

export const ContainerBox = styled(Box)(({ theme }) => ({
    display: "flex",
    flexDirection: "row",
    backgroundColor: theme.palette.core.grey._20,
    padding: theme.spacing(6),
    borderRadius: theme.shape.borderRadius,
    boxShadow: theme.shadow.boxShadow.sm,
    overflow: "hidden",

    [theme.breakpoints.up("md")]: {
        width: 320,
        flexDirection: "column",
        alignSelf: "flex-start",
    },
}));

export const LeftBox = styled(Box)(({ theme }) => ({
    width: 212,
    [theme.breakpoints.up("sm")]: {
        width: "unset",
    },
}));

export const TitleTypography = styled(Typography)({
    overflowWrap: "break-word",
});

export const MarginBottomBox = styled(Box)(({ theme }) => ({
    marginBottom: theme.spacing(3),
}));

export const LargeImageContainer = styled(Box)(({ theme }) => ({
    display: "none",
    [theme.breakpoints.up("md")]: {
        display: "flex",
        flex: 1,
        justifyContent: "center",
    },
}));

export const SmallImageContainer = styled(Box)(({ theme }) => ({
    display: "flex",
    flex: 1,
    marginLeft: theme.spacing(4),
    [theme.breakpoints.up("md")]: {
        display: "none",
    },
}));

export const SmallImageStatic = styled(ImageStatic)(() => ({
    objectPosition: "0 0",
}));

export const StyledButton = styled(Button)(({ theme }) => ({
    display: "flex",
    alignSelf: "flex-start",

    [theme.breakpoints.up("md")]: {
        marginTop: -24,
    },
}));
